import type { PropsWithChildren } from 'react';
import { forwardRef } from 'react';
import { Target } from './styles';

export const PopoverTarget = forwardRef<HTMLSpanElement, PropsWithChildren<any>>(({ children, ...props }, ref) => (
  <Target {...props} ref={ref}>
    {children}
  </Target>
));
